import React, { useEffect, useState } from "react";
import PageHeader from "../Components/PageHeader";
import Header from "../Components/Header";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { LOGIN_SUCCESS, USER_DETAIL } from "../redux/Slices/AuthSlice";
import {
	getPhysicianSpecializationtapi,
	physicianeditprofileapi,
} from "../network/Network";
import Select from "react-select";

function Physicianinfoedit() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userDetail = useSelector((state) => state?.Auth?.users);
	console.log(userDetail,"asd")
	const token = useSelector((state) => state?.Auth?.token);
	const [formErrors, setFormErrors] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selected, setSelected] = useState("");
	const [getSpecial, setGetSpecial] = useState([]);
	const [selectedOption, setSelectedOption] = useState("");
	const [userData, setUserData] = useState({
		first_name: userDetail?.first_name,
		last_name: userDetail?.last_name,
		phone: userDetail?.phone?.replace(/^\+1|\+44/, "") || "",
		countryCode: userDetail?.phone?.startsWith("+44") ? "+44" : "+1", // default to +1
		address: userDetail?.address,
		country: userDetail?.country,
		city: userDetail?.city,
		state: userDetail?.state,
		zip_code: userDetail?.zip_code,
		degree_title: userDetail?.degree_title,
		experience: userDetail?.experience,
	});

	const specializationOptions = [
		{ value: "pediatrics", label: "Pediatrics" },
		{ value: "neurology", label: "Neurology" },
		{ value: "adnarology", label: "adnarology" },
		{ value: "sharicology", label: "sharicology" },
		{ value: "adnarology1", label: "adnarology1" },
		{ value: "sharicology1", label: "sharicology1" },
	];

	const [selectedSpecializations, setSelectedSpecializations] = useState();

	const specialSelection = selectedSpecializations?.map((item) => item?.label);
	console.log(specialSelection, "spela");

	const [selectedFile, setSelectedFile] = useState(null);

	// const allhandleChange = (selectedOptions) => {
	// 	setSelectedSpecializations(selectedOptions);
	// };

	const allhandleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions || []);
	};

	// Map the data to the required format for react-select
	// const formattedOptions = getSpecial.map((item) => ({
	// 	value: item?.id,
	// 	label: item?.title,
	// }));
	const formattedOptions = getSpecial.map((item) => ({
		value: item?.id,
		label: item?.title,
	}));

	// Event handler for the select box
	const handleSelectChange = (event) => {
		setSelectedOption(event.target.value);
	};

	//  Get Specialization Api
	// useEffect(() => {
	// 	getPhysicianSpecializationtapi().then((res) => {
	// 		setGetSpecial(res?.data);
	// 	});
	// }, []);

	useEffect(() => {
		if (userDetail?.specialization && getSpecial.length > 0) {
			try {
				const parsed = JSON.parse(userDetail.specialization); // Convert string to array
				const preselected = getSpecial
					.map((item) => ({
						value: item?.id,
						label: item?.title,
					}))
					.filter((option) => parsed.includes(option.label));

				setSelectedSpecializations(preselected); // Show pre-filled specializations
			} catch (e) {
				console.error("Failed to parse Specialty:", e);
			}
		}
	}, [userDetail, getSpecial]);

	useEffect(() => {
		getPhysicianSpecializationtapi().then((res) => {
			setGetSpecial(res?.data);
		});
	}, []);

	// ====================

	//   Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================
	const handleCountryCode = (e) => {
		const value = e.target.value;
		setUserData((prev) => ({
			...prev,
			countryCode: value,
			phone: "",
		}));
		// setUserData({ ...userData, phone: "" });
		// setUserData({ ...userData, countryCode: value });
	};
	//   Edit Profile Handler
	const editprofilehandler = (e) => {
		e.preventDefault();
		setLoading(true);
		let isValid = true;
		const errors = {};

		// Validation checks
		if (!userData?.first_name) {
			errors.first_name = ["First Name is required"];
			isValid = false;
		}
		if (!userData?.last_name) {
			errors.last_name = ["Last Name is required"];
			isValid = false;
		}
		// Validate Phone Number
		if (!userData?.phone) {
			errors.phone = ["Phone is required"];
			isValid = false;
		} else {
			const phone = userData.phone.trim();

			if (userData.countryCode === "+1") {
				if (!/^\d{10}$/.test(phone)) {
					errors.phone = ["USA phone number must be exactly 10 digits"];
					isValid = false;
				}
			} else if (userData.countryCode === "+44") {
				if (!/^\d{8,10}$/.test(phone)) {
					errors.phone = ["UK phone number must be between 8 and 10 digits"];
					isValid = false;
				}
			} else {
				errors.phone = ["Invalid country code selected"];
				isValid = false;
			}
		}

		if (!userData?.address) {
			errors.address = ["Address is required"];
			isValid = false;
		}
		if (!userData?.country) {
			errors.country = ["Country is required"];
			isValid = false;
		}
		if (!userData?.city) {
			errors.city = ["City is required"];
			isValid = false;
		}
		if (!userData?.state) {
			errors.state = ["State is required"];
			isValid = false;
		}
		if (!userData?.zip_code) {
			errors.zip_code = ["Zip Code/Postal Code is required"];
			isValid = false;
		}
		if (!userData?.degree_title) {
			errors.degree_title = ["Degree title is required"];
			isValid = false;
		}
		if (!userData?.experience) {
			errors.experience = ["Experience is required"];
			isValid = false;
		}

		// Show errors
		setFormErrors(errors);

		// 🚫 If not valid, stop here
		if (!isValid) {
			setLoading(false);
			return;
		}

		// ✅ If valid, continue to API call
		const data = {
			first_name: userData?.first_name,
			last_name: userData?.last_name,
			phone: `${userData.countryCode}${userData.phone.trim()}`,
			address: userData?.address,
			country: userData?.country,
			city: userData?.city,
			state: userData?.state,
			zip_code: userData?.zip_code,
			degree_title: userDetail?.degree_title,
			experience: userDetail?.experience,
			specialization: specialSelection,
		};

		physicianeditprofileapi(userDetail?.id, data, token)
			.then((res) => {
				dispatch(LOGIN_SUCCESS(res?.data?.data));
				setFormErrors([]);
				dispatch(USER_DETAIL(res?.data?.data));
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Congratulations! Your Profile Has Been Updated",
					showConfirmButton: false,
					timer: 1500,
				});

				navigate("/physician-personal-info");
				setLoading(false);
			})
			.catch((err) => {
				setFormErrors([]);

				setLoading(false);
				const errorData = err?.response?.data?.errors;

				if (errorData) {
					Object.values(errorData)
						.flat()
						.forEach((message) => {
							Swal.fire({
								position: "center",
								icon: "error",
								text: message,
								showConfirmButton: false,
								timer: 2200,
							});
						});
				}
			});
	};

	// ====================

	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link to="/physician-personal-info">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Edit Personal Info
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="firstName"
												name="first_name"
												placeholder=" First Name"
												value={userData?.first_name}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.first_name}</p>
										</div>
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" Last Name"
												name="last_name"
												value={userData?.last_name}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.last_name}</p>
										</div>
										<div className="form-group col-lg-12">
											<div className="input-group vertical-ll">
												<select
													className="form-control"
													style={{
														maxWidth: "100px",
														borderRadius: "80px 0 0px 80px",
														border: "1px solid #869b96",
														background: "transparent",
													}}
													value={userData?.countryCode}
													name="countryCode"
													onChange={handleCountryCode}
												>
													<option value="+1">+1 (USA)</option>
													<option value="+44">+44 (UK)</option>
												</select>
												<input
													type="tel"
													className="form-control"
													id="phone"
													placeholder="Phone number"
													name="phone"
													value={userData?.phone}
													onChange={(e) => {
														const value = e.target.value.replace(/\D/g, ""); // remove non-digits
														if (value.length <= 10) {
															handleChange({
																target: { name: "phone", value },
															});
														}
													}}
													maxLength={10}
												/>
											</div>
											<p className="forms-error">{formErrors?.phone}</p>
										</div>
										<div className="form-group col-lg-12 position-relative">
											<input
												type="text"
												className="form-control"
												id="address"
												placeholder="Address"
												name="address"
												value={userData?.address}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.address}</p>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-4">
											<input
												type="text"
												className="form-control"
												id="city"
												placeholder=" City"
												name="city"
												value={userData?.city}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.city}</p>
										</div>
										<div className="form-group col-lg-4">
											<input
												type="text"
												className="form-control"
												id="state"
												placeholder="State"
												name="state"
												value={userData?.state}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.state}</p>
										</div>
										<div className="form-group col-lg-4">
											<input
												type="number"
												className="form-control"
												id="zip_code"
												placeholder=" Zip Code/Postal Code "
												name="zip_code"
												value={userData?.zip_code}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.zip_code}</p>
										</div>
									</div>
									<div className="row mb-2 mt-2">
										<div className="col-lg-12">
											<div>
												{/* <Select
													isMulti
													name="specializations"
													isSearchable={false}
													options={formattedOptions}
													className="basic-multi-select"
													classNamePrefix="select"
													onChange={allhandleChange}
													value={selectedSpecializations}
													placeholder="Area of Specialization"
													menuPortalTarget={document.body} // <-- This is key
													styles={{
														menuPortal: (base) => ({ ...base, zIndex: 9999 }), // zIndex high rakhein
													}}
												/> */}
												<Select
													isMulti
													name="specializations"
													isSearchable={false}
													options={formattedOptions}
													className="basic-multi-select"
													classNamePrefix="select"
													onChange={allhandleChange}
													value={selectedSpecializations}
													placeholder="Area of Specialty"
													menuPortalTarget={document.body}
													styles={{
														menuPortal: (base) => ({ ...base, zIndex: 9999 }),
													}}
												/>

												<p className="forms-error">
													{formErrors?.selectedSpecializations}
												</p>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												id="experience"
												placeholder="Years of Experience"
												name="experience"
												value={userData?.experience}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.experience}</p>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												id="phone"
												placeholder="Enter Degree Title"
												name="degree_title"
												value={userData?.degree_title}
												onChange={handleChange}
											/>
											<p className="forms-error">{formErrors?.degree_title}</p>
										</div>
									</div>
									<Link className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none">
										<span
											onClick={(e) => editprofilehandler(e)}
											className="loading-btn loading bg-wrapper "
											style={{ zIndex: "1" }}
										>
											{loading ? <i className="fa fa-spinner"></i> : "Save"}
										</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default Physicianinfoedit;
